import React, { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Tooltip, Typography } from 'antd';

import {
  formatProjectLabelFromCompanySettings,
} from '../../projects/projectHelpers';

/**
 * Component to display project names in Gantt schedule columns
 * Uses company settings to determine naming convention (name, number, or both)
 * Styled similarly to GanttScheduleTableInput display mode
 */
function GanttScheduleProjectColumn({ projectId }) {
  const projects = useSelector((state) => state.projects.projects);
  const { settings = {} } = useSelector((state) => state.settings.company);

  const [isTruncated, setIsTruncated] = useState(false);

  const displayValue = useMemo(() => {
    const project = projects.find((p) => p.id === projectId);
    if (!project) return '';
    return formatProjectLabelFromCompanySettings({
      name: project.name,
      number: project.number,
      settings,
    });
  }, [projectId, projects, settings]);

  return (
    <Tooltip
      placement="topLeft"
      title={isTruncated ? displayValue : undefined}
      destroyTooltipOnHide
    >
      <Typography.Paragraph
        style={{
          height: 30,
          display: 'table-cell',
          verticalAlign: 'middle',
          maxWidth: 250,
          minWidth: 250,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
        ellipsis={{
          rows: 1,
          onEllipsis: setIsTruncated,
        }}
      >
        {displayValue}
      </Typography.Paragraph>
    </Tooltip>
  );
}

GanttScheduleProjectColumn.propTypes = {
  projectId: PropTypes.string.isRequired,
};

export default GanttScheduleProjectColumn;
